module.exports = __webpack_public_path__ + "media/images/common/order_limit_bg-16b8dd35a773b5f9d36e2af9ced0a16d.png";